// src/head/vr.js
(function(){
  try {
    window.__STOCKSTORM_HEAD = (window.__STOCKSTORM_HEAD || {});
    window.__STOCKSTORM_HEAD.vr = true;
    if (typeof console !== 'undefined' && console.log) {
      console.log('StockStorm: vr head bundle loaded');
    }

    // Align with desktop model-viewer loading logic
    var params = new URLSearchParams(location.search);
    var mv = params.get('mv');
    var shouldLoad = (mv === null || mv === '' || mv === '1' || String(mv).toLowerCase() === 'true');

    var isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
    var isRetinaMobile = isMobile && window.devicePixelRatio && window.devicePixelRatio >= 2;
    
    let storedQualityLevel = null;
    try {
      const rawSettings = localStorage.getItem('mainSettings');
      if (rawSettings) storedQualityLevel = JSON.parse(rawSettings)?.value?.quality;
    } catch (e) {}

    function getOptimalPixelRatio() {
      if (typeof window === 'undefined') return 1;
      let isWeakGPU = true;
      try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (gl) {
          const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
          if (debugInfo) {
            const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL).toLowerCase();
            if (
              renderer.includes('nvidia') || 
              renderer.includes('rtx') || 
              renderer.includes('gtx') || 
              renderer.includes('apple') ||
              (renderer.includes('radeon') && !renderer.includes('graphics')) ||
              renderer.includes('radeon rx') ||
              renderer.includes('adreno (tm) 6') ||
              renderer.includes('adreno (tm) 7') ||
              renderer.includes('mali-g7') ||
              renderer.includes('mali-g6')
            ) {
              isWeakGPU = false;
            }
          }
        }
      } catch (e) {}

      const maxPixels = isWeakGPU ? 2500000 : 5500000;
      const screenWidth = window.innerWidth || 1920;
      const screenHeight = window.innerHeight || 1080;
      const screenPixels = screenWidth * screenHeight;
      const targetDPR = Math.sqrt(maxPixels / screenPixels);
      const nativeDPR = window.devicePixelRatio || 1;
      
      let finalDPR = Math.min(nativeDPR, targetDPR);
      finalDPR = Math.max(1.0, finalDPR);
      return Math.round(finalDPR * 10) / 10;
    }

    const activeQualityLevel = storedQualityLevel || (isMobile ? 'performance' : 'quality');
    const isQuality = activeQualityLevel === 'quality';
    
    window.__STOCKSTORM_CONFIG = {
      mv: shouldLoad,
      bloom: params.has('bloom') ? (params.get('bloom') !== '0' && params.get('bloom') !== 'false') : isQuality,
      pixelRatio: parseFloat(params.get('pr')) || getOptimalPixelRatio(),
      antialias: params.has('aa') ? (params.get('aa') !== '0' && params.get('aa') !== 'false') : isQuality,
      highRefreshRate: params.has('hrr') ? (params.get('hrr') !== '0' && params.get('hrr') !== 'false') : isQuality,
      foveationLevel: params.has('fl') ? parseInt(params.get('fl')) : (isQuality ? 0 : 1),
    };
    setLevelQuality();

    if (shouldLoad) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    } else {
      console.info('[MV] Skipping model-viewer load via ?mv=0');
    }
  } catch (_) { /* no-op */ }
})();

function setLevelQuality() {
  const scene = document.getElementById('main-scene');
  if (!scene) return
  const config = window.__STOCKSTORM_CONFIG || {};
  console.log('Applying configuration: ', config)

  // Set renderer tweaks
  const pr = config.pixelRatio || 1.5;
  scene.setAttribute('renderer-tweaks', 'pixelRatio: ' + pr);
  // scene.setAttribute('renderer-tweaks', 'pixelRatio: 2');

  // Set renderer
  const aa = (config.antialias !== undefined) ? config.antialias : true;
  const hrr = (config.highRefreshRate !== undefined) ? config.highRefreshRate : true;
  const fl = (config.foveationLevel !== undefined) ? config.foveationLevel : 0;
  scene.setAttribute('renderer', 'antialias: ' + aa + '; highRefreshRate: ' + hrr + '; foveationLevel: ' + fl + ';');

  // Set bloom
  const bloomEnabled = (config.bloom !== undefined) ? config.bloom : true;
  scene.setAttribute('bloom', 'threshold: 1; strength: 0.2; radius: 0.1;');
}

if (typeof AFRAME !== 'undefined') {
  AFRAME.registerComponent('renderer-tweaks', {
    schema: { pixelRatio: { type: 'number', default: (window.__STOCKSTORM_CONFIG && window.__STOCKSTORM_CONFIG.pixelRatio) || 1.5 } },
    init: function () {
      const renderer = this.el.sceneEl.renderer;
      if (renderer) {
        renderer.setPixelRatio(this.data.pixelRatio);
        console.log('Pixel Ratio Set To:', renderer.getPixelRatio());
      }
    }
  });
}

import '../../vr_scripts/lightweight-charts.js';
import '../../js/aframe-environment-component.js';
import '../../js/aframe-html.js';
// import '../../post-processing/bloom.js';
